module.exports = __webpack_public_path__ + "img/stacje-meteo.94f3da68.svg";